
import jsPDF from "jspdf";

const setCustomText = (doc, text, x, y, fontSize, fontWeight) => {
  doc.setFontSize(fontSize);
  doc.setFont(undefined, fontWeight)
  doc.text(text, x, y, { maxWidth: 116, align: 'left' });
};

export const generatePDF = (contentImage, appLink) => {

  const doc = new jsPDF();

  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();

  doc.addImage(contentImage, 'PNG', 40, 20, width / 2 + 30, height / 2);

  setCustomText(doc, `How to pay a PayShap QR code`, 76, 180, 12, "bold");

  doc.setFontSize(11)
  doc.textWithLink("Click here", 74, 190, { url: `${appLink}` });

  setCustomText(doc, 'to register on scan and pay', 94, 190, 11, "normal");

  setCustomText(doc, 'Or', width /2, 198, 11, "normal");

  setCustomText(doc, "Register for PayShap on your bank's app or online banking and pay", 54, 206, 11, "normal");
  
  doc.save("image.pdf")
};
